<template>
  <div>
    <div class="input-field col s12" v-if="!isPasswordReset">
      <input
        type="password"
        id="ChangePasswordCurrentPassword"
        data-cy="settings-form-currentpassword"
        v-model="currentPassword"
        :placeholder="$t('views.settings.currentPassword')"
      />
      <label for="ChangePasswordCurrentPassword"></label>
      <errors :field="v$.currentPassword" />
    </div>
    <div>
      <s-text-input
        :placeholder="$t('views.settings.newPassword')"
        id="ChangePasswordNewPassword"
        data-cy="settings-form-newpassword"
        :type="showNewPassword ? 'text' : 'password'"
        :icon="showNewPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :icon-callback="
          () => {
            showNewPassword = !showNewPassword;
          }
        "
        :icon-title="!showNewPassword ? 'Visa lösenord' : 'Dölj lösenord'"
        v-model="newPassword"
        @focus="showPasswordIndicator = true"
        @blur="hidePasswordIndicator"
        :rounded="round"
      ></s-text-input>

      <s-password-indicator
        :class="!isPasswordReset ? 'small' : null"
        :show="showPasswordIndicator || newPassword.length > 0"
        :value="newPassword"
        :theme="theme"
      ></s-password-indicator>
      <errors :field="v$.newPassword" />
    </div>
    <flex-grid :force-row="true" class="button-container mt20">
      <s-button
        :small="true"
        :dark="true"
        :flat="true"
        class="underline"
        data-cy="settings-form-clearpasswordbutton"
        :to="{ name: 'start' }"
        v-if="isPasswordReset"
        >{{ $t('generic.cancel') }}</s-button
      >
      <s-button
        id="ButtonSave"
        color="blue"
        :small="true"
        :loading="loading"
        element-name="settings-form-changepasswordbutton"
        @click="saveNewPassword()"
        >{{ $t('generic.save') }}</s-button
      >
    </flex-grid>
    <div v-if="sendError" class="error center-text">
      {{ $t('views.settings.changePasswordError') }}
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import AuthService from '@common/Services/AuthService';
import FlexGrid from '@common/Components/Grids/FlexGrid.vue';

export default {
  setup() {
    return {
      v$: useVuelidate()
    };
  },
  components: { FlexGrid },
  props: {
    resetCode: String,
    theme: {
      type: String,
      default: 'light'
    },
    round: Boolean
  },
  data() {
    return {
      currentPassword: '',
      newPassword: '',
      showNewPassword: false,
      loading: false,
      sendError: false,
      showPasswordIndicator: false
    };
  },
  validations() {
    const validations = {
      newPassword: { required },
      currentPassword: {}
    };

    if (!this.isPasswordReset) {
      validations.currentPassword = { required };
    }

    return validations;
  },
  methods: {
    hidePasswordIndicator() {
      setTimeout(() => {
        this.showPasswordIndicator = false;
      }, 100);
    },
    saveNewPassword() {
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      }

      this.loading = true;
      if (this.isPasswordReset) {
        this.sendError = false;
        AuthService.changePasswordFromReset(this.resetCode, this.newPassword)
          .then(() => {
            this.$router.push('/login');
          })
          .catch(err => {
            console.log(err.message);
            this.sendError = true;
          })
          .finally(() => (this.loading = false));
      } else {
        AuthService.changePassword(this.currentPassword, this.newPassword)
          .then(() => {
            this.v$.$reset();
            this.$emit('success');
          })
          .catch(error => {
            this.$emit('error', error.Message);
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  computed: {
    isPasswordReset() {
      return this.resetCode;
    }
  }
};
</script>

<style lang="scss" scoped>
.info {
  font-size: smaller !important;
  font-style: italic;
}
.small {
  font-size: 0.8em;
}
.password-indicator {
  color: black;
}
.error {
  padding-top: 15px;
  color: #c55;
}
</style>
